import { useI18nContext } from '@/contexts/I18nContext'

const useI18n = () => useI18nContext()

export default useI18n